import Sidebar from "./Sidebar";
import { Toaster } from "sonner";

export default function AppLayout({ children }) {
  return (
    <div className="App flex min-h-screen bg-background">
      <Sidebar />
      <main className="flex-1 min-w-0">{children}</main>
      <Toaster
        position="top-right"
        toastOptions={{
          className: "font-sans",
          style: { background: "hsl(var(--card))", color: "hsl(var(--card-foreground))", border: "1px solid hsl(var(--border))" },
        }}
      />
    </div>
  );
}
